<script>
	import Icon from './General/Icon.svelte';
	import { translate } from '../lib/translate';

	export let light;
	export let title    = '';
	export let subTitle = ''
	export let specs    = [];
	export let location = '';
	export let refNo  = '';
</script>

<div class="content" class:light>
	<h1>{title}</h1>
	{#if subTitle}
		<h3>{subTitle}</h3>
	{/if}
	<div class="specs">
		{#each specs as row}
			<div class="spec-row">
				{#each row as spec}
					<div class="spec">{translate(spec)}</div>
				{/each}
			</div>
		{/each}
	</div>
	<div class="location">
		<Icon
			name="MAP_MARKER"
			size="9"
			color="#C8C8C8"
		/>
		<span>{location}</span>
	</div>
	<div class="ref-no">
		<span>{translate('Ref. no.')}</span>{refNo}
	</div>
</div>

<style type="text/scss" lang="scss">
	.content {
		width: 330px;
		padding-bottom: 28px;
		justify-self: flex-end;
		position: relative;
		color: var(--c-primary);
		z-index: 1;

		&.light {
			color: white;
		}

		h1 {
			font-size: 32px;
			font-weight: 600;
			line-height: 49px;
		}

		h3 {
			line-height: 25px;
			font-size: 16px;
			font-weight: 400;
			&:not(:last-child) {
				margin-bottom: 17px;
			}
		}

		.specs {
			opacity: 0.8;
			.spec-row {
				display: flex;
				.spec {
					font-size: 12px;
					line-height: 18px;

					&:not(:last-child)::after {
						content: "|";
						width: 30px;
						text-align: center;
						display: inline-block;
					}
				}
			}
			&:not(:last-child) {
				margin-bottom: 22px;
			}
		}

		.location {
			font-size: 12px;
			line-height: 18px;
			display: flex;
			align-items: center;
			opacity: 0.8;

			&:not(:last-child) {
				margin-bottom: 23px;
			}

			span {
				margin-left: 8px;
			}
		}

		.ref-no {
			font-weight: 600;

			span {
				font-weight: initial;
				opacity: .8;
				margin-right: 6px;
			}
		}
	}
</style>
